import { Filter as CommonFilter, FilterProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getFilterConfig } from './config';
import { useStores } from 'src/hooks/query/use-stores';
import { useUsers } from 'src/hooks/query/use-users';

type MergeRequestFilterProps = Omit<FilterProps, 'items'> & {
  searchOnly?: boolean;
};

export const Filter = ({ searchOnly = false, ...props }: MergeRequestFilterProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-merge-requests.list',
  });
  const size = 2;

  const filterConfig = searchOnly
    ? []
    : getFilterConfig({ t, size });

  return (
    <CommonFilter
      {...props}
      items={filterConfig}
      searchInputProps={{
        placeholder: t('filter.search.placeholder'),
      }}
    />
  );
};
